



































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";

import ModulesJson from "../../shared/ModulesJson";
import CategoryTypeJson, {
  defaultCategoryTypeJson,
  validateCategoryTypeJson,
  validateCategoryTypeJsonAddNew,
} from "../../shared/CategoryTypeJson";
import { CategoryTypeType, getCategoryTypeType } from "../../shared/CategoryTypeType";

import SettingsJson from "../../shared/SettingsJson";
import { UserPermissionRank, UserPermissionRankNames } from "../../shared/UserPermissionRank";
import UserPermission, { defaultUserPermissionJson } from "../../shared/UserPermission";
import { UserPermissionType, UserPermissionTypeNames } from "../../shared/UserPermissionType";
import UserPermissionTypeInfoJson, { UserPermissionTypeInfos } from "../../shared/UserPermissionTypeInfoJson";
import { validateUserJson } from "../../shared/UserJson";
import { ValidationResult, Validation } from "../../shared/Validation";

export default Vue.extend({
  name: "SettingsCategoryTypeForm",
  components: {
    OverlayWindow,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    allActiveModules: Array as PropType<ModulesJson[]>,
    categoryTypeType: String as PropType<CategoryTypeType>,
    mode: String,
    editable: Boolean,
    categoryTypeId: Number,
  },
  data() {
    return {
      allCategoryTypes: null as CategoryTypeJson[] | null,
      selectedId: null as number | null,
      details: null as CategoryTypeJson | null,
      hasChanges: false,
      toValidate: {} as any,
      validation: null as ValidationResult<CategoryTypeJson> | null,
      submitValidation: false as boolean,
      frontendValidations: {
        title: false,
      },
      titleTimeout: null as any,
      loadingGeneral: false as boolean,
      loadingTitleAvailability: false as boolean,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.details = null;
      this.selectedId = this.categoryTypeId;
      this.loadAllCategoryTypes();
      this.loadDetails();
    },

    async loadAllCategoryTypes() {
      this.allCategoryTypes = null;

      try {
        this.allCategoryTypes = await this.restClient.getCategoryTypes();
      } catch (e) {
        alert(e.message);
      }
    },

    async loadDetails() {
      if (this.selectedId != null) {
        if (this.restClient != null) {
          try {
            this.details = await this.restClient.getCategoryType(this.selectedId);
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.details = this.getDefaultCategoryTypeData();
        this.details.colorHexString = this.getRandomHexColorString();
      }

      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    getDefaultCategoryTypeData() {
      return { ...defaultCategoryTypeJson(), type: this.compCategoryTypeType };
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("close");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("close");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.validation = validateCategoryTypeJson(this.details);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    async checkTitleAvailability() {
      this.loadingTitleAvailability = true;
      clearTimeout(this.titleTimeout);

      let vue = this;

      this.titleTimeout = setTimeout(async function () {
        if (vue.details != null && vue.details.title != "") {
          try {
            let availability: boolean = await vue.restClient.getCategoryTypeTitleAvailability(vue.details.title, [
              vue.details.type,
            ]);
            vue.frontendValidations.title = !availability;
            vue.loadingTitleAvailability = false;
          } catch (err) {
            alert(err.message);
            vue.loadingTitleAvailability = false;
          }
        } else {
          vue.frontendValidations.title = false;
          vue.loadingTitleAvailability = false;
        }
      }, 600);
    },

    async addNewCategoryType() {
      if (this.details != null) {
        this.loadingGeneral = true;

        this.submitValidation = true;

        this.validation = validateCategoryTypeJsonAddNew(this.details);

        if (this.validation != null && this.validation.isValid == true && !this.frontendValidations.title) {
          if (this.restClient != null) {
            try {
              this.details = await this.restClient.addCategoryType(this.details);
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.closeDetails();
              alert("Die Kategorie wurde erfolgreich hinzugefügt.");
            } catch (e) {
              this.loadingGeneral = false;
              alert(e.message);
            }
          }
        } else {
          this.loadingGeneral = false;
          alert("Die Kategorie konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveCategoryType() {
      if (this.details != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;

          this.validation = validateCategoryTypeJson(this.details);

          if (this.validation != null && this.validation.isValid == true && !this.frontendValidations.title) {
            if (this.restClient != null) {
              try {
                this.details = await this.restClient.updateCategoryType(this.details);
                this.hasChanges = false;
                this.loadingGeneral = false;
                alert("Die Änderungen wurden erfolgreich gespeichert.");
                this.closeDetails();
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
          this.closeDetails();
        }
      }
    },

    async deleteCategoryType() {
      if (this.selectedId != null) {
        let c = confirm("Wollen Sie diese Kategorie wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteCategoryType(this.selectedId);
              this.closeDetails();
              alert("Die Kategorie wurde gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    getRandomHexColorString() {
      //Thanks to https://stackoverflow.com/a/5092846
      return "#" + ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, "0");
    },
  },

  watch: {
    details: {
      handler() {
        this.hasChanges = true;
      },
      deep: true,
    },

    categoryTypeId: {
      handler() {
        this.init();
      },
    },

    loadingGeneral: {
      handler() {
        this.$emit("loading", this.loadingGeneral || this.loadingTitleAvailability);
      },
    },

    loadingTitleAvailability: {
      handler() {
        this.$emit("loading", this.loadingGeneral || this.loadingTitleAvailability);
      },
    },
  },

  computed: {
    allUsedGroupings(): string[] {
      let groupings: string[] = [];

      if (this.allCategoryTypes) {
        for (let categoryType of this.allCategoryTypes) {
          if (categoryType.grouping) {
            groupings.push(categoryType.grouping);
          }
        }
      }

      return [...new Set(groupings)];
    },

    compCategoryTypeType(): CategoryTypeType {
      return getCategoryTypeType(this.categoryTypeType, this.settings.useGeneralCategoryTypes);
    },
  },
});
